import { render, staticRenderFns } from "./LaboralFunctionAddEdit.vue?vue&type=template&id=154cd63e"
import script from "./LaboralFunctionAddEdit.vue?vue&type=script&lang=js"
export * from "./LaboralFunctionAddEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports